import { Elm } from "./Vigenere.elm";

Elm.Vigenere.init({ node: document.getElementById('app') });
